import { useTranslation } from 'react-i18next';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const VALUE_ICONS = ['ri-shield-check-line', 'ri-eye-line', 'ri-leaf-line', 'ri-heart-line'];

const TEAM = [
  {
    name: 'Alexandra Reid',
    role: 'Chief Executive Officer',
    img: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20confident%20businesswoman%20CEO%20in%20her%2040s%20with%20blonde%20hair%2C%20elegant%20corporate%20attire%2C%20warm%20authoritative%20smile%2C%20clean%20studio%20background%2C%20executive%20portrait%20photography&width=300&height=300&seq=team1&orientation=squarish',
  },
  {
    name: 'Daniel Park',
    role: 'Chief Operations Officer',
    img: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20an%20Asian%20male%20executive%20in%20his%2040s%2C%20sharp%20business%20suit%2C%20confident%20smile%2C%20clean%20neutral%20background%2C%20corporate%20leadership%20portrait%20photography&width=300&height=300&seq=team2&orientation=squarish',
  },
  {
    name: 'Amara Osei',
    role: 'VP of Technology',
    img: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20young%20African%20woman%20tech%20executive%20in%20her%2030s%2C%20smart%20business%20casual%20attire%2C%20bright%20intelligent%20smile%2C%20clean%20white%20background%2C%20modern%20corporate%20portrait&width=300&height=300&seq=team3&orientation=squarish',
  },
  {
    name: 'Lucas Ferreira',
    role: 'Head of Global Logistics',
    img: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20Brazilian%20man%20in%20his%20late%2030s%2C%20logistics%20executive%2C%20business%20attire%2C%20friendly%20confident%20expression%2C%20clean%20office%20studio%20background%2C%20corporate%20portrait%20photography&width=300&height=300&seq=team4&orientation=squarish',
  },
];

const VALUE_KEYS = [
  { titleKey: 'about.value1.title', descKey: 'about.value1.desc' },
  { titleKey: 'about.value2.title', descKey: 'about.value2.desc' },
  { titleKey: 'about.value3.title', descKey: 'about.value3.desc' },
  { titleKey: 'about.value4.title', descKey: 'about.value4.desc' },
];

const STAT_KEYS = [
  { value: '2014', labelKey: 'about.stat.founded' },
  { value: '180+', labelKey: 'about.stat.countries' },
  { value: '2.4M+', labelKey: 'about.stat.deliveries' },
  { value: '50k+', labelKey: 'about.stat.partners' },
];

export default function AboutPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <div className="relative pt-20 overflow-hidden" style={{ minHeight: '420px' }}>
        <img
          src="https://readdy.ai/api/search-image?query=aerial%20view%20of%20a%20large%20modern%20logistics%20distribution%20center%20at%20dawn%2C%20rows%20of%20delivery%20trucks%20and%20cargo%20planes%20lined%20up%2C%20teal%20and%20green%20warehouse%20lights%2C%20professional%20drone%20photography%2C%20industrial%20scale%20facility%2C%20organized%20freight%20operations&width=1920&height=500&seq=about1&orientation=landscape"
          alt="SwiftTrack logistics facility"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#071818]/90 via-[#071818]/70 to-transparent" />

        <div className="relative z-10 max-w-7xl mx-auto px-6 py-24">
          <div
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold tracking-wider mb-6 border"
            style={{ background: 'rgba(13,148,136,0.2)', borderColor: 'rgba(13,148,136,0.4)', color: '#5eead4' }}
          >
            {t('about.badge')}
          </div>
          <h1 className="font-heading font-bold text-5xl text-white mb-5 max-w-xl">
            {t('about.headline')}
          </h1>
          <p className="text-white/70 text-lg max-w-lg leading-relaxed">
            {t('about.subtext')}
          </p>
        </div>
      </div>

      {/* Stats bar */}
      <div style={{ background: 'var(--primary)' }} className="py-10">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {STAT_KEYS.map(({ value, labelKey }) => (
            <div key={labelKey}>
              <div className="font-heading font-bold text-3xl text-white mb-1">{value}</div>
              <div className="text-white/70 text-sm">{t(labelKey)}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Mission */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
            <div>
              <div
                className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold tracking-wider mb-6 border"
                style={{ background: 'var(--primary-light)', borderColor: 'color-mix(in srgb, var(--primary) 30%, transparent)', color: 'var(--primary-dark)' }}
              >
                {t('about.mission.badge')}
              </div>
              <h2 className="font-heading font-bold text-4xl text-gray-900 mb-6">
                {t('about.mission.title1')} <br />
                <span style={{ color: 'var(--primary)' }}>{t('about.mission.title2')}</span>
              </h2>
              <p className="text-gray-600 text-base leading-relaxed mb-6">
                {t('about.mission.p1')}
              </p>
              <p className="text-gray-600 text-base leading-relaxed">
                {t('about.mission.p2')}
              </p>
            </div>
            <div className="rounded-2xl overflow-hidden" style={{ height: '420px' }}>
              <img
                src="https://readdy.ai/api/search-image?query=modern%20logistics%20control%20center%20with%20large%20screens%20showing%20global%20delivery%20routes%20and%20tracking%20maps%2C%20team%20of%20professionals%20working%20at%20computers%2C%20teal%20green%20accent%20lighting%2C%20high%20tech%20operations%20center%2C%20wide%20angle%20photography&width=700&height=500&seq=about2&orientation=landscape"
                alt="SwiftTrack operations center"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20" style={{ background: '#f0fdfa' }}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-14">
            <h2 className="font-heading font-bold text-4xl text-gray-900 mb-4">
              {t('about.values.title')}
            </h2>
            <p className="text-gray-500 text-lg max-w-xl mx-auto">
              {t('about.values.subtitle')}
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-7">
            {VALUE_KEYS.map(({ titleKey, descKey }, i) => (
              <div key={titleKey} className="bg-white rounded-2xl p-7 border border-gray-100">
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mb-5"
                  style={{ background: 'var(--primary)' }}
                >
                  <i className={`${VALUE_ICONS[i]} text-xl text-white`} />
                </div>
                <h3 className="font-heading font-semibold text-gray-900 text-lg mb-3">{t(titleKey)}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{t(descKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-14">
            <h2 className="font-heading font-bold text-4xl text-gray-900 mb-4">
              {t('about.team.title1')} <span style={{ color: 'var(--primary)' }}>{t('about.team.title2')}</span>
            </h2>
            <p className="text-gray-500 text-lg max-w-lg mx-auto">
              {t('about.team.subtitle')}
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {TEAM.map(({ name, role, img }) => (
              <div key={name} className="text-center">
                <div className="w-full rounded-2xl overflow-hidden mb-4" style={{ height: '200px' }}>
                  <img
                    src={img}
                    alt={name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="font-semibold text-gray-900 text-sm">{name}</div>
                <div className="text-gray-500 text-xs mt-1">{role}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
